import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { useSetState } from 'Utils/Helpers/Hooks';
import { useDispatch } from 'react-redux';
import { getPatients, saveNewPatient } from 'http/components/PatientService';
import { SetPatientData } from 'Utils/Helpers/HandleApiData';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { enqueueSnackbar } from 'notistack';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewPatientMain() {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false);
  const [ready, setReady] = useState(false);
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'نام و نام خانوادگی',
      value: '',
      icon: <icons.PersonSquare/>,
      force: true,
    },
    nCode: {
      id: "nCode",
      type: 'number',
      placeholder: 'کد ملی',
      value: '',
      icon: <icons.AppIndicator/>,
      force: false,
    },
    uniCode: {
      id: "uniCode",
      type: 'text',
      placeholder: 'شماره پرونده',
      value: '',
      icon: <icons.CardList/>,
      force: true,
    },
    mobile: {
      id: "mobile",
      type: 'number',
      placeholder: 'شماره موبایل',
      value: '',
      icon: <icons.Telephone/>,
      force: false,
    },
  });

  const onEnter = () => {
    setControls({ name: { value: '' } });
    setControls({ mobile: { value: '' } });
    setControls({ nCode: { value: '' } });
    setControls({ uniCode: { value: '' } });
    setReady(true);
  }

  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  const setShowDialog = () => {
    setReady(false);
    setShow(true);
  }

  const handleClose= () => {
    setShow(false);
  }

  const onFinish = async () => {
    const {name, nCode, uniCode, mobile} = controls;
    dispatch(HandleLoading(true));
    if(name.value !== '' && uniCode.value !== '') {
      const response = await saveNewPatient(name.value, nCode.value, uniCode.value, mobile.value);
      if(response.status) {
        const response2 = await getPatients();
        if(response2.status) {
            await dispatch(SetPatientData(response2.data))
            enqueueSnackbar('بیمار جدید با موفقیت اضافه شد', {variant: 'success'});
            setShow(false);
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است، فیلد‌های ستاره دار الزامی می باشند', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
      <div className='home-btn-add'>
        <CButton
            text={'اضافه کردن بیمار جدید'}
            icon={<icons.PlusCircle/>}
            onClick={setShowDialog}
            className='home-btn h-lg with-shadow with-OP07'
        />
      </div>
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          TransitionProps={{onEnter: onEnter}}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          {
            ready &&
            <>
              <DialogTitle>
                {"اضافه کردن بیمار جدید"}
                <div className='close-btn' onClick={handleClose}>
                  <icons.X/>
                </div>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-appointment-edit">
                  <div className='flex-column-center-center w-100 px-2'>
                    {
                      Object.keys(controls).map((key, index) => {
                        return (
                          <Inputer
                            key={`inputer_${controls[key].id}`}
                            id={controls[key].id}
                            type={controls[key].type}
                            placeholder={controls[key].placeholder}
                            value={controls[key].value}
                            setValue={setControlsValue.bind(this)}
                            force={controls[key].force}
                            icon={controls[key].icon}
                            className={'mb-2'}
                          />
                        )
                      })
                    }
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <CButton
                  text={'ذخیره بیمار جدید'}
                  icon={<icons.Save2/>}
                  onClick={onFinish}
                />
              </DialogActions>
            </>
          }
        </Dialog>
      }
    </>
  );
}